var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoresults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.054,
    height: 166.388,
    viewBox: "0 0 201.054 166.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5473",
    "data-name": "Grupo 5473",
    transform: "translate(-862.482 -422.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5472",
    "data-name": "Grupo 5472",
    transform: "translate(862.482 412.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5470",
    "data-name": "Grupo 5470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3541",
    "data-name": "Rect\\xE1ngulo 3541",
    width: 182.124,
    height: 98.895,
    rx: 14,
    transform: "translate(3.917 77.764)",
    fill: "#f0f1f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_3536",
    "data-name": "Rect\\xE1ngulo 3536",
    transform: "translate(0 75.805)",
    fill: "#fff",
    stroke: "#f1f1f1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.124,
    height: 98.895,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 178.124,
    height: 94.895,
    rx: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5471",
    "data-name": "Grupo 5471",
    transform: "translate(157.792 0) rotate(17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5469",
    "data-name": "Grupo 5469",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3537",
    "data-name": "Rect\\xE1ngulo 3537",
    width: 19.583,
    height: 96.937,
    rx: 8,
    transform: "translate(28.342 7.874) rotate(17)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3538",
    "data-name": "Rect\\xE1ngulo 3538",
    width: 11.66,
    height: 20.562,
    rx: 5.83,
    transform: "translate(35.131 0) rotate(17)",
    fill: "#c20e30"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3539",
    "data-name": "Rect\\xE1ngulo 3539",
    width: 4.896,
    height: 7.833,
    rx: 2,
    transform: "matrix(0.951, 0.309, -0.309, 0.951, 7.24, 99.116)",
    fill: "#c20e30"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3540",
    "data-name": "Rect\\xE1ngulo 3540",
    width: 4.896,
    height: 7.833,
    rx: 2,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 179.162, 25.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4073",
    "data-name": "Trazado 4073",
    d: "M3378.23,18269.789s52.339-2.918,39.452-16.625-28.346,35.25-28.346,35.25-2.057,5.723-2.161,5.746c-3.2,5.883-24.181.332-8.945-10.1,18.095-12.391,52.722,0,52.722,0l10.981-25.551",
    transform: "translate(-2449.369 -17736.656)",
    fill: "none",
    stroke: "#b0b0b0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresults);
export default __webpack_public_path__ + "static/media/noresults.99d525d1db8f78290cef937f3212f5ce.svg";
export { ForwardRef as ReactComponent };